import { createSelector } from "reselect"
import { get, map } from "lodash"
import { getSwap, getAccount } from "."

const STEPS = [{
  id: "upload",
  label: "Select Files",
  submitButton: {
    isDisabled: ({ files }) => files.length === 0,
    text: "Scan files",
  },
}, {
  id: "upload/preview",
  label: "Scan Preview",
  submitButton: {
    isDisabled: ({ uploadOption, uploadedFiles, availableFrom }) => {
      if (availableFrom) {
        return !uploadOption || uploadedFiles.length === 0
      } else {
        return uploadedFiles.length === 0
      }
    },
    text: "Begin upload",
  },
}, {
  id: "upload/complete",
  label: "Upload Complete",
}]

export const getActiveStep = state => get(state, "modules.swapPositions.activeStep")

export const getSteps = createSelector(
  [getSwap, getAccount],
  (swap, account) => {
    if (!swap) {
      return STEPS
    } else {
      return map(STEPS, step => ({ ...step, url: `/${account}/baskets/${swap.ticker}/${step.id}` }))
    }
  },
)
